// src/pages/User/CreateAdminUser.js
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import adminUserService from "../../services/api/admin-user-service";
import {Container} from "reactstrap";


const PERMISSIONS = [
  "BUSINESS_LISTING",
  "USERS_LIST",
  "CONTACT_US",
  "REPORTS",
  "VEHICLE_LOAD",
  "RATE_CARD",
  "FULL_ACCESS"
];

class CreateAdminUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      userId: null,
      form: {
        contactName: "",
        username: "",
        email: "",
        password: "",
        permissions: [],
        userType: "SUB_ADMIN",
        status: "A"
      },
      error: null
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const userId = match?.params?.id;
    if (userId) {
      this.setState({ userId, loading: true });
      adminUserService.getUserById(userId)
        .then(user => {
          const form = {
            contactName: user.contactName || "",
            username: user.username || "",
            email: user.email || "",
            password: "", // blank - only set if change
            permissions: user.permissions || [],
            userType: user.userType || "SUB_ADMIN",
            status: user.status || "A"
          };
          this.setState({ form, loading: false });
        })
        .catch(err => {
  console.error("API ERROR !", err);
  const details = err.response && err.response.data ? err.response.data : err.message;
  alert("Failed to save user: " + JSON.stringify(details));
  this.setState({ saving: false });
});

    }
  }

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => ({ form: { ...prev.form, [name]: value } }));
  };

  onTogglePermission = (perm) => {
    this.setState(prev => {
      const perms = new Set(prev.form.permissions || []);
      if (perms.has(perm)) perms.delete(perm);
      else perms.add(perm);
      return { form: { ...prev.form, permissions: Array.from(perms) } };
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { form, userId } = this.state;

    // basic validation
    if (!form.username || !form.contactName) {
      alert("Please provide username (phone) and Contact Name.");
      return;
    }

  
  const payload = {
  contactName: form.contactName,
  username: form.username,       // phone login
  contactNumber: form.username,  // REQUIRED by MtUser
  email: form.email,
  permissions: form.permissions,
  userType: "SUB_ADMIN",
  status: form.status,
  isTermsAgreed: true,      // your model requires it
  phoneVerified: true       // required for login
};

    // Only include password for creation or when changed
    if (!userId && form.password) payload.password = form.password;
    if (!userId && !form.password) {
      alert("Please provide password for the new user.");
      return;
    }
    if (userId && form.password) payload.password = form.password;

    this.setState({ saving: true });
    const action = userId ? adminUserService.updateUser(userId, payload) : adminUserService.createUser(payload);

    action.then(() => {
      alert(userId ? "User updated" : "User created");
      this.setState({ saving: false });
      this.props.history.push("/AdminUsersList");
    }).catch(err => {
    console.error("CREATE USER ERROR:", err);

    let msg = "Failed to save user";

    if (err?.response?.data?.error?.message?.includes("exists")) {
      msg = "Phone number is already registered!";
    }

    this.setState({ error: msg, saving: false });
  });
}

  render() {
    
    const { form, loading, saving } = this.state;

    if (loading) return <p>Loading user...</p>;

    return (
      <React.Fragment>
            <div className="page-content">
            <Container fluid>
      
        <h4>{this.state.userId ? "Edit User" : "Create User"}</h4>

        <div className="card">
          <div className="card-body">
          {this.state.error && (
  <div className="alert alert-danger">
    {this.state.error}
  </div>
)}
  
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>Contact Name</label>
                <input className="form-control" name="contactName" value={form.contactName} onChange={this.onChange} />
              </div>

              <div className="form-group">
                <label>Username (phone)</label>
                <input className="form-control" name="username" value={form.username} onChange={this.onChange} />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input className="form-control" name="email" value={form.email} onChange={this.onChange} />
              </div>

              <div className="form-group">
                <label>Password {this.state.userId ? "(leave blank to keep current)" : ""}</label>
                <input type="password" className="form-control" name="password" value={form.password} onChange={this.onChange} />
              </div>

              <div className="form-group">
                <label>Permissions</label>
                <div>
                  {PERMISSIONS.map(perm => (
                    <div className="form-check form-check-inline" key={perm}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`perm-${perm}`}
                        checked={(form.permissions || []).includes(perm)}
                        onChange={() => this.onTogglePermission(perm)}
                      />
                      <label className="form-check-label" htmlFor={`perm-${perm}`}>{perm}</label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>Status</label>
                <select name="status" className="form-control" value={form.status} onChange={this.onChange}>
                  <option value="A">Active</option>
                  <option value="I">Inactive</option>
                </select>
              </div>

              <div className="mt-3">
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? "Saving..." : (this.state.userId ? "Update User" : "Create User")}
                </button>
                <button type="button" className="btn btn-secondary ml-2" onClick={() => this.props.history.push("/AdminUsersList")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        </Container>
              </div>
            </React.Fragment>
      
    );
  }
}

export default withRouter(CreateAdminUser);
